<template>
    <div class="solution-box">
        <Marketing :marketingData='marketingData' class="block"></Marketing>
        <Video class="block"></Video>
        <Service :serviceData='serviceData' class="white"></Service>
        <FromBanner :msg='msg'></FromBanner>
    </div>
</template>
<script>
    import Marketing from '@/components/main/home/marketing'//引入数字化营销服务
    import Video from '@/components/main/project/video'//引入视屏内容
    import Service from '@/components/main/project/service'//引入服务介绍
    import FromBanner from '@/components/base/frombanner'//引入联系我们的banner模块     
    export default {
        name: 'Solution',
        data() {
            return {
                marketingData: {//第四屏的数据
                    title: '产品拍摄',
                    caption: 'Video',
                    showdown: 'Shooting',
                    textData: ['ENCOURAGE POSITIVE FEEDBACK SHARE', 'INNOVATION CULTIVATE INDUSTRY PROFESSIONAL'],
                    chinese: '<p>您是否正在寻找一种有效的方法来提高企业的品牌知名度和网站流量？</p><p>然后，您应该在社交媒体上！</p><p>获取我们的社交媒体推广服务，并建立强大的社交媒体形象。</p>',
                    // english: '<p>我们拥有10年数字营销与网站设计开发经验、 100多项经典案例。</p><p>我们的成员由数字营销策划、交互设计、数字前端及整合平台研发专家组成。</p>',
                },
                serviceData: {
                    caption: '视频拍摄',
                    center: '到目前为止，搜索引擎依然是网站流量的最大来源，SEO依然是最有效的网络营销手段。我们的SEO服务帮助您全面提升网站搜索引擎排名表现，提升关键词排名，带来自然流量，进而提升公司销售和利润。',
                    itemData: [
                        {
                            imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/tj/mowa.jpg',
                            caption: '企业轻视频-智能照明行业',
                            video: '//player.bilibili.com/player.html?aid=286569409&bvid=BV1Rf4y1X7nd&cid=219823691&page=1'
                        },
                        {
                            imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/tj/kq.jpg',
                            caption: '企业轻视频-眼镜行业',
                            video: '//player.bilibili.com/player.html?aid=883925336&bvid=BV1hK4y1x7jA&cid=213806102&page=1'
                        },
                        {
                            imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/case/%E4%BC%81%E4%B8%9A%E5%BE%AE%E4%BF%A1%E6%88%AA%E5%9B%BE_15950575664879.png',
                            caption: '产品轻视频-户外LED行业',
                            video: '//player.bilibili.com/player.html?aid=243914634&bvid=BV1Kv411q7CR&cid=213800068&page=1'
                        },
                        {
                            imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/tj/mm.jpg',
                            caption: '产品轻视频-智能家居行业',
                            video: '//player.bilibili.com/player.html?aid=711519158&bvid=BV19D4y1m7sV&cid=219813270&page=1'
                        }
                    ]
                },
                msg: {
                    caption: '诊断您的网站SEO布局和关键词布局定制海外营销计划',
                    botton: '联系我们',
                }
            }
        },
        components: {
            Marketing,
            Video,
            Service,
            FromBanner
        }
    }
</script>
<style scoped>
    .marketing-box>>>.english-box p,
    .marketing-box>>>.chinese-box p {
        font-size: 16px;
        font-weight: 400;
        line-height: 32px;
        color: rgba(102, 102, 102, 1);
    }

    .marketing-box>>>.right-box {
        display: none;
    }

    .marketing-box>>>.text-box {
        width: 56.7%;
        height: 570px;
        grid-template-columns: 100%;
        left: 100%;
        transform: translateX(-100%);
    }

    .marketing-box>>>.text-box::before {
        content: '';
        display: block;
        position: absolute;
        top: -60%;
        left: -80%;
        width: 100%;
        height:100%;
        background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/photo-1589872307379-0ffdf9829123.jpg') no-repeat center;
        background-size: cover;
    }

    .solution-box>>>.marketing-box {
        padding-top: 561px;
        min-height: 1131px;
    }

    .marketing-box>>>.marquee-text {
        padding-top: 0;
        transform: translateY(-110%);
    }

    .marketing-box>>>.showdown {
        padding-left: 16px;
    }
    .marketing-box>>>.left-box::before,.marketing-box>>>.animetionLine{
        display: none;
    }

    .service-box>>>.imgbox {
        height: 23.7vw;
    }

    .service-box>>>.item-box {
        cursor: pointer;
    }

    .service-box>>>.topCenter-bx {
        background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/comi/%E7%BB%84%20762.jpg') no-repeat center;
        background-size: cover;
        background-attachment: fixed;
    }
    .service-box>>>.circle{
        display: block;
    }
    @media(max-width: 995px){
        .solution-box>>>.marketing-box {
        padding-top:0px;
        min-height: auto;
    }
    .marketing-box>>>.marquee-text {
       display: none;
    }
    .marketing-box>>>.text-box {
        width:100%;
        height: auto;
        transform: translateX(0%);
    }
    .marketing-box>>>.left-box {
        justify-content: flex-start;
    }
    .service-box>>>.imgbox {
        height:55vw;
    }
    }

    /* @media(max-width: 1023px) {
        .marketing-box>>>.text-box::before {
            display: none;
        }

        .marketing-box>>>.text-box {
            width: 100%;
            height: 570px;
            grid-template-columns: 1fr;
            left: 0;
            transform: translateX(0);
            position: relative;
        }

        .marketing-box>>>.left-box {
            width: 100%;
            background-color: #ffffff;
        }

        .marketing-box>>>.english-box p,
        .marketing-box>>>.chinese-box p {
            font-size: 50px;
            line-height: 200%;
        }

        .solution-box>>>.marketing-box {
            padding-top: 0;
            height: 1300px;
        }

        .marketing-box>>>.marquee-text {
            padding-top: 0;
            transform: translateY(40%);
        }

        .service-box>>>.topCenter-bx {
            background-attachment: initial;
        }
        .service-box>>>.center{
            color: #fff;
        }
        .service-box>>>.imgbox {
        height: 950px;
    }

    }
    @media(max-width: 375px){
        .solution-box>>>.marketing-box {
        height: 1500px;
    }
    }
    @media(max-width: 320px){
        .solution-box>>>.marketing-box {
        height: 1600px;
    }
    }
    @media(max-width: 360px){
        .service-box>>>.topCenter-bx {
            height: 1500px;
        }
    } */
</style>


// WEBPACK FOOTER //
// src/pages/main/porject/solution.vue